/** @format */
import angular from 'angular';
import { formErrorTranslateFilterModule } from './formErrorTranslateFilter';
import { localeServiceModule } from './localeService';
import { localizedStringFilterModule } from './localizedStringFilter';

export const l10nModule = 'sis-common.l10n';

(function () {
    angular.module(l10nModule, [localeServiceModule, localizedStringFilterModule, formErrorTranslateFilterModule]);
})();
